import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Modal from 'components/Modal';
import Input from 'components/Input';
import Button from 'components/Button';
import ModalHeader from 'components/ModalHeader';

import { setStorage } from 'utilz';

import './styles.scss';
import containerActions from './actions';

class EmailPage extends React.Component {
  state = { email: '' }

  emailChangeHandl = (e) => {
    this.setState({ email: e.target.value });
  }

  sendEmailHandl = () => {
    this.props.saveEmailHandl(this.state.email);
    setStorage({
      email: {
        email: this.state.email,
        isOpen: false
      }
    });
  }

  validateEmail = (email) => {
    // eslint-disable-next-line
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  closeEmail = () => {
    this.props.toggleEmailHandl();
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen}>
        <ModalHeader backHandl={this.closeEmail} iconType="cross">
                Provide an email
        </ModalHeader>
        <div className="modal-email">

          <div className="email-wrapper">
            <Input
              changeHandl={this.emailChangeHandl}
              placeholder="Your Email"
              value={this.state.email}
              type="email"
            />

            {
                !this.validateEmail(this.state.email) && this.state.email !== '' ?
                (
                  <p style={{ color: 'red', marginTop: 10, fontSize: 12 }}>
                    Email incorrect
                  </p>
                ) : null
            }


            <Button
              onClick={this.sendEmailHandl}
              disabled={!this.validateEmail(this.state.email)}
            >
                Save email
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

EmailPage.propTypes = {
  toggleEmailHandl: PropTypes.func.isRequired,
  saveEmailHandl: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired

};

const mapToStateProps = state => ({
  isOpen: state.email.isOpen
});

export default connect(mapToStateProps, containerActions)(EmailPage);



// WEBPACK FOOTER //
// ./src/pages/Email/index.js